<template>
  <div>
    <div
      v-if="!file || autoUpload"
      :class="['file-container', dragging ? 'over' : '']"
      @dragenter.prevent="setActive"
      @dragover.prevent="setActive"
      @dragleave.prevent="setInactive"
      @drop.prevent="onChange"
    >
      <v-row align="end">
        <v-progress-circular
          v-if="loading"
          :size="30"
          color="#26384B"
          indeterminate
        />
        <v-icon
          v-else
          large
        >
          cloud_download
        </v-icon>
      </v-row>
      <v-row>
        <span class="title">{{ $t('forms.labels.dragandDrop') }}</span>
        <div class="file-browse">
          <span class="title">{{ $t('forms.labels.browse') }}</span>
          <input
            type="file"
            :accept="accept"
            data-cy="dragAndDrop"
            :disabled="disabled"
            @change="onChange"
          >
        </div>
      </v-row>
      <v-row v-if="showPdfResizeMsg">
        <div><span class="title">{{ $t('forms.labels.resizePdf') }}</span></div>
      </v-row>
    </div>
    <div
      v-else
      class="fileUploaded"
    >
      <span>{{ file.name }}</span>
      <v-icon @click="removeFile">
        mdi-close
      </v-icon>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import validationProviderHelperMixin from '@/components/shared/widgets/forms/validationHelper/validationProviderHelperMixin';

export default {
    mixins: [
        validationProviderHelperMixin,
    ],
    props: {
        file: {
            type: File,
            default: () => {},
        },
        mimes: {
            type: Array,
            default: () => ['application/pdf'],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        autoUpload: {
            type: Boolean,
            default: false,
        },
        showPdfResizeMsg: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dragging: false,
        };
    },
    computed: {
        accept() {
            return Array.isArray(this.mimes) ? this.mimes.join(',') : null;
        },
    },
    methods: {
        onChange(e) {
            const files = e.target.files || e.dataTransfer.files;
            const [file] = files;
            const wrongExtension = !this.mimes.includes(file.type);
            if (!files || wrongExtension) {
                if (wrongExtension) {
                    Vue.toasted.global.toast_error({
                        message: this.$t('errors.dragAndDrop.wrongExtension'),
                    });
                }
                this.setInactive();
                return;
            }
            this.$emit('onChange', file);
            this.setInactive();
        },
        removeFile() {
            this.$emit('removeFile');
        },
        setActive() {
            this.dragging = true;
        },
        setInactive() {
            this.dragging = false;
        },
    },
};
</script>

<style lang="scss" scoped>
    .file-container {
        height: 126px;
        text-align: center;
        align-items: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background: #E8E8E8;
        border: 1px dashed #757575;
        .title {
            color: #757575;
            font-weight: 400;
            font-size: 16px !important;
        }
    }
    .file-browse {
        position: relative;
        width: auto;
        margin-left: 5px;
        text-decoration-line: underline;
    }
    .file-container input {
        position: absolute;
        cursor: pointer;
        width: 100%;
        opacity: 0;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
    .over {
        opacity: 0.2;
        .title {
            color: black;
        }
    }
    .fileUploaded {
        min-height: 200px;
        justify-content: center;
        align-items: center;
        display: flex;
    }
</style>
